import { css } from 'styled-components';
import FontConfig, { IEnvironmentTypes } from './Font.config';

const Font = (environment: IEnvironmentTypes) =>
  css`
    @font-face {
      font-family: 'Brandon Text';
      font-display: auto;
      font-weight: 300;
      font-style: normal;
      src: url(${FontConfig.cdnBaseUrl[environment]}/fonts/BrandonText-Light.otf);
    }

    @font-face {
      font-family: 'Brandon Text';
      font-display: auto;
      font-weight: 400;
      font-style: normal;
      src: url(${FontConfig.cdnBaseUrl[environment]}/fonts/BrandonText-Regular.otf);
    }

    @font-face {
      font-family: 'Brandon Text';
      font-display: auto;
      font-weight: 700;
      font-style: normal;
      src: url(${FontConfig.cdnBaseUrl[environment]}/fonts/BrandonText-Bold.otf);
    }
  `;

export default Font;
